/* eslint-disable react-hooks/rules-of-hooks */

import React from 'react';
import Head from 'next/head';
import { defineNextPage } from '@/common/next';
import { getEnv, navigate } from '@/common/agents';

import dynamic from 'next/dynamic';
import { UserMessage } from '$/pages/RoboneoChatBoard/type';
import { isMobile } from '$/utils';
import { buildPopupData } from '$/utils/messageUtil';

const RoboneoShare = dynamic(
  () => import('$/pages/RoboneoShare'),
  { ssr: false },
);
const RoboneoMobileShare = dynamic(
  () => import('$/pages/RoboneoMobileShare'),
  { ssr: false },
);

export const SHARE_TRY_MINE_KEY = 'share_try_mine_data';
// import calc from './calc.svg';

export default defineNextPage<{
  title: string;
}>({
  pageConfig: {
    projectId: '/--roboneo',
    layoutId: 'RoboneoLayout',
    renderHead() {
      return <Head><title>RoboNeo</title></Head>;
    },
  },
  async getInitialProps() {
    return {
      title: 'share',
    };
  },
  component: () => {
    const searchParams = new URLSearchParams(window.location.search);
    const source = searchParams.get('source') || 'web';
    const onShortLinkError = () => {
      navigate({
        mode: 'url',
        url: getEnv().ENV === 'development' ? '/--roboneo/home' : '/home',
        replace: true,
      });
    };

    const onDownload = () => {
      navigate({
        mode: 'url',
        url: getEnv().ENV === 'development' ? '/--mobile/download' : '/download',
        query: {
          from: source === 'web' ? 'shareweb' : 'sharemobile',
        },
      });
    };

    const onTryMine = (messageList?: UserMessage[][]) => {
      // 提取第一条用户消息的文本/图片/视频/文件，通过 sessionStorage 传递给首页
      const firstGroup = messageList?.[0] || [];
      const userMsg = firstGroup.find((msg) => msg.role === 'user');
      if (userMsg) {
        const payload = buildPopupData({
          room_id: '',
          text: userMsg.content || '',
          markElementList: userMsg.markElementList,
          images: userMsg.imageList as any,
          videos: userMsg.videoList as any,
          documents: userMsg.fileList as any,
          isAutoSubmit: false,
        });
        sessionStorage.setItem(SHARE_TRY_MINE_KEY, JSON.stringify(payload));
      }
      const targetHomePath = userMsg ? 'home_old' : 'home';
      navigate({
        mode: 'url',
        url: getEnv().ENV === 'development' ? `/--roboneo/${targetHomePath}` : `/${targetHomePath}`,
      });
    };

    const renderComp = () => {
      return isMobile()
        ? (
          <RoboneoMobileShare
            source={source}
            onTryMine={onDownload}
            onShortLinkError={onShortLinkError}
            onDownload={onDownload}
            // chatLogoInfo={{
            //   logoText:"share",
            //   defaultDarkLogo: calc,
            // }}
          />
        )
        : (
          <RoboneoShare
            onTryMine={onTryMine}
            onShortLinkError={onShortLinkError}
            // headerLogo={calc}
            // chatLogoInfo={{
            //   logoText: 'share',
            //   defaultLightLogo: calc,
            // }}
          />
        );
    };
    return (
      renderComp()
    );
  },
});
